const locale = require('./quotableProductTemplates.i18n.json');

/*@ngInject*/
const QuotableProductTemplatesModalController = function ($rootScope, $scope, options, coreConstant) {

    $scope.i18n = locale;

    $scope.viewModel = {
        quotableProducts: options.quotableProducts,
        selectedQuotableProductId: -1,
        selectedQuotableProductIds: [],
        isProposalAction: options.isProposalAction,
        inputType: options.isProposalAction ? 'checkbox' : 'radio',
        title: _.get($scope.i18n, 'title'),
        cancelButton: _.get($scope.i18n, 'cancel'),
        okButton: options.isProposalAction === true ? _.get($scope.i18n, 'createProposal') : _.get($scope.i18n, 'createQuote')
    };

    $scope.canEnableConfirmButton = function () {
        return !($scope.viewModel.isProposalAction === true ? $scope.viewModel.selectedQuotableProductIds.length === 0 : $scope.viewModel.selectedQuotableProductId === -1);
    };

    $scope.getRequiredIndicatorValue = function () {
        if ($scope.viewModel.isProposalAction) {
            return $scope.viewModel.selectedQuotableProductIds.length !== 0 ? 'true' : '';
        } else {
            return $scope.viewModel.selectedQuotableProductId !== -1 ? 'true' : '';
        }
    };

    $scope.handleClick = function (quotableProduct) {
        if ($scope.viewModel.isProposalAction) {
            if (_.indexOf($scope.viewModel.selectedQuotableProductIds, quotableProduct.id) === -1) {
                $scope.viewModel.selectedQuotableProductIds.push(quotableProduct.id);
            } else {
                _.pull($scope.viewModel.selectedQuotableProductIds, quotableProduct.id);
            }
        } else {
            $scope.viewModel.selectedQuotableProductId = quotableProduct.id;
        }
    };

    $scope.onConfirm  = function () {
        $scope.$close({
            selectedQuotableProductId: $scope.viewModel.selectedQuotableProductId,
            selectedQuotableProductIds: $scope.viewModel.selectedQuotableProductIds
        });
    };

    $scope.onCancel = function () {
        $scope.$dismiss();
    };

    $scope.$on(coreConstant.event.MODAL_CLOSING, function () {
        $rootScope.$broadcast(coreConstant.event.MODAL_CLOSED);
    });

    $rootScope.$broadcast(coreConstant.event.MODAL_OPENED);
};

angular.module('gw-um-submission')
    .controller('quotableProductTemplatesModalController', QuotableProductTemplatesModalController);
